module.exports = __webpack_public_path__ + "static/media/kyledavies@2x.37f77d3d.jpg";